export const GET_NZ_VARIABLES = 'GET_NZ_VARIABLES'
export const RESET_VARIABLES = 'RESET_VARIABLES'
